import type { PropsWithoutRef, SVGProps } from "react";

export default function InfoIcon({ ...props }: PropsWithoutRef<SVGProps<SVGElement>>) {
	return (
		<svg
			width="13"
			height="13"
			viewBox="0 0 13 13"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6.5 0C2.9104 0 0 2.91145 0 6.5C0 10.0906 2.9104 13 6.5 13C10.0896 13 13 10.0906 13 6.5C13 2.91145 10.0896 0 6.5 0ZM6.5 2.88306C7.10796 2.88306 7.60081 3.37591 7.60081 3.98387C7.60081 4.59183 7.10796 5.08468 6.5 5.08468C5.89204 5.08468 5.39919 4.59183 5.39919 3.98387C5.39919 3.37591 5.89204 2.88306 6.5 2.88306ZM7.96774 9.54032C7.96774 9.71401 7.82692 9.85484 7.65323 9.85484H5.34677C5.17308 9.85484 5.03226 9.71401 5.03226 9.54032V8.91129C5.03226 8.7376 5.17308 8.59677 5.34677 8.59677H5.66129V6.91935H5.34677C5.17308 6.91935 5.03226 6.77853 5.03226 6.60484V5.97581C5.03226 5.80211 5.17308 5.66129 5.34677 5.66129H7.02419C7.19789 5.66129 7.33871 5.80211 7.33871 5.97581V8.59677H7.65323C7.82692 8.59677 7.96774 8.7376 7.96774 8.91129V9.54032Z"
				fill="currentColor"
			/>
		</svg>
	);
}
